import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { ExternalLink } from "components/common";
const URLhausAdapterDocumentation = () => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "urlhaus.documentation.description",
      components: { siteLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://urlhaus.abuse.ch/" }) }
    }
  )));
};
export default URLhausAdapterDocumentation;
